import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../core/auth.service';
import { BaseService } from '../shared/base.service';
import { BaseComponent } from '../shared/base.component';
import { AppService } from '../app.service';
import { TemplatesService } from './templates.service';
import { HELP_CLINIC_PROFILE, HELP_TEMPLATE_LIST } from '../shared/constants/help-buttons';
import { PopoverService } from '../shared/popover/popover.service';
import {ClinicsService} from "../clinics/clinics.service";

@Component({
    selector: 'templates-component',
    templateUrl: 'templates.component.html',
    styleUrls: ['templates.component.scss'],
    providers: [
        TemplatesService, ClinicsService,
    ]
})

export class TemplatesComponent extends BaseComponent implements OnInit {
    successMessage: string = '';
    allTemplates: any;
    searchTerms: string = '';
    txtNoEmailTemplate: string = 'You have no email template.';
    clinicId = 0;
    clinic: any;
    HELP_TEMPLATE_LIST = HELP_TEMPLATE_LIST;
    HELP_CLINIC_PROFILE = HELP_CLINIC_PROFILE;

    constructor(public authService: AuthService,
                public router: Router,
                public baseService: BaseService,
                public templatesService: TemplatesService,
                public appService: AppService,
                public popoverService: PopoverService,
                public clinicService: ClinicsService,
                public route: ActivatedRoute) {
        super(authService, router, baseService, appService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.route.queryParams.subscribe( params =>{
           if(params['clinic_id'] && params['clinic_id'] > 0){
               this.clinicId = params['clinic_id'];
               this.clinicService.read(this.clinicId).subscribe( response => {
                  this.clinic = response['clinic'];
                   // set helpTemplates
                   this.popoverService.setHelpContent(response['helpTemplates']);
               });
               return this.getTemplatesByClinic(this.clinicId);
           }
        });
        if(!this.clinicId){
            return this.getAllTemplates();
        }
    }

    /**
     * Search email template
     */
    search() {
        if (!this.searchTerms) {
            if (!this.clinicId) {
                return this.getAllTemplates();
            }
            return this.getTemplatesByClinic(this.clinicId);
        }

        this.templatesService.search(this.searchTerms, this.clinicId).subscribe((response) => {
            if (response['length'] === 0) {
                this.txtNoEmailTemplate = 'No email template is matched your search criteria.';
            }

            this.allTemplates = response['templates'];
        });
    }

    resetSearch() {
        this.searchTerms = '';
        this.getAllTemplates();
    }

    getTemplatesByClinic(clinicId) {
        this.appService.isLoading = true;
        this.templatesService.getByClinic(this.clinicId).subscribe(response => {
            this.allTemplates = response;
            this.appService.isLoading = false;
        });

    }

    getAllTemplates() {
        this.appService.isLoading = true;
        this.templatesService.all().subscribe((response) => {
            this.allTemplates = response['templates'];

            // set helpTemplates
            this.popoverService.setHelpContent(response['helpTemplates']);
            this.appService.isLoading = false;
        });
    }
}
